import { Field, MarkdownTextarea } from '@payaca/ambrosia';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { z } from 'zod/v4';

export const LINE_ITEM_TITLE_DESCRIPTION_FORM_SCHEMA = z.object({
  description: z.string().min(1),
});

export type TLineItemTitleDescriptionFormState = z.infer<
  typeof LINE_ITEM_TITLE_DESCRIPTION_FORM_SCHEMA
>;

type TProps = {
  className?: string;
};

const TitleDescriptionField: FC<TProps> = (props) => {
  const { className } = props;

  const formMethods = useFormContext<TLineItemTitleDescriptionFormState>();

  return (
    <Field.Legacy
      className={className}
      validationState={
        formMethods.formState.errors.description
          ? {
              isValid: false,
              validationMessages: ['Title & Description is required'],
            }
          : undefined
      }
    >
      <Field.Label>Title & description</Field.Label>

      <Controller
        name="description"
        render={({ field: { onChange, onBlur, value } }) => {
          return (
            <MarkdownTextarea
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              aria-label="Title & description"
            />
          );
        }}
      />
    </Field.Legacy>
  );
};

export default TitleDescriptionField;
